// setup splide sliders
function setupSplide() {
    if (document.querySelector("#js-product-image-slider")) {
        const splide = new Splide("#js-product-image-slider", {
            type: "loop",
            padding: "4rem",
            gap: "1rem",
            arrows: false
        });
        splide.mount();
    }
}
setupSplide();
const splideColorChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.productColorChange, (event) => {
    // wait until all images are loaded before initializing splide
    const splideImages = document.querySelectorAll("#js-product-image-slider .splide__slide img");
    const splideImagesLoaded = [];
    splideImages.forEach((image) => {
        image.addEventListener("load", () => {
            splideImagesLoaded.push(image);
            if (splideImagesLoaded.length === splideImages.length) {
                setupSplide();
            }
        });
    });
});
